import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import {
  Combo2Service,
  ComboService,
  SalesOrderService,
  StockService
} from "../../../services/index";
import { SaleDC } from "../../../services/salesDc.service";
declare var google;

@Component({
  selector: "purchaseOrder",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./brandStock.html",
})
export class brandStockComponent implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  brand: string;
  printPreview: any;
  gridOptions: any;
  dataList = [];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  printData;
  noofpcs: number;
  box: boolean;
  shirt: boolean;
  groupbyList = ["RETAIL", "WHOLESALE", "ESTIMATE"];
  filter = {
    party_id: "",
    party_name: "",
    agent_name: "",
    agent_id: "",
    order_from_date: "",
    order_to_date: "",
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "so_no",
    orderDir: "asc",
  };
  finyearList = [];
  agentList = [];
  seasonfinList = [];
  partyAgentList = [];
  partyList = [];

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("orderTemplate") orderTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;
  @ViewChild("box_printTemplate") box_printTemplate: TemplateRef<any>;
  @ViewChild("fsStkTemplate") fsStkTemplate: TemplateRef<any>;
  @ViewChild("hsStkTemplate") hsStkTemplate: TemplateRef<any>;
  @ViewChild("totStkTemplate") totStkTemplate: TemplateRef<any>;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  groupCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];
  menu: any;
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    private salesservice: SalesOrderService,
    private combo2Service: Combo2Service,
    private modalService: BsModalService,
    public toasterService: ToasterService,
    private comboservice: ComboService,
    private saleDC: SaleDC,
    private stockService: StockService,

  ) {}

  ngOnInit(): void {
    this.getColumns();
    this.getPartyList();
    this.agentCombo();
    this.toggleCol = Object.assign({}, this.columns);
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        headerClass: "text-center",
        sortable: false,
        cellTemplate: this.snoTemplate,
        toggle: true,
        cellClass: "text-center",
      },
      {
        name: "Brand",
        prop: "brand",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
      },
      {
        name: "Ref no",
        prop: "so_no",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      {
        name: "Inw.Date",
        prop: "so_dateformatted",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
      },
      {
        name: "F.Tot",
        prop: "ftotpcs",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
      },
      {
        name: "H.Tot",
        prop: "htotpcs",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
      },
      {
        name: "Tot.Pcs",
        prop: "totpcs",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
      },
      {
        name: "F.Stk",
        prop: "fs_stock",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
        cellTemplate: this.fsStkTemplate,
      },
      {
        name: "H.Stk",
        prop: "hs_stock",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
        cellTemplate: this.hsStkTemplate,
      },
      {
        name: "Tot.Stk",
        prop: "tot_stock",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 70,
        maxWidth: 70,
        width: 70,
        cellTemplate: this.totStkTemplate,
      },
      {
        name: "Action",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        sortable: false,
        cellTemplate: this.editDeleteTemplate,
      },
      {
        name: "Sticker",
        prop: "sno",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
        cellClass: "text-center",
        sortable: false,
        cellTemplate: this.box_printTemplate,
      },
    ];
    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#party_code").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      setTimeout(() => {
        $("#" + nextEl).focus();
      }, 300);
    }
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getOrderList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  clearFilter(): void {
    this.filter.party_name = "";
    this.filter.party_id = "";
    this.filter.agent_name;
    this.filter.agent_id = "";
    this.filter.order_from_date = "";
    this.filter.order_to_date = "";
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    if (this.filter.agent_name == "") {
      this.filter.agent_id = "";
    }
    if (this.filter.party_name == "") {
      this.filter.party_id;
    }
    this.filterPanel.close();
    this.getOrderList();
  }

  loadSeasonList() {
    let that = this;
    this.combo2Service.seasonCombo().then(function (res) {
      //  this.LoadAgentList();
      that.seasonList = res.data;
      that.seasonCtrl.setValue(res.data[0].season_id);
    });
  }
  agentCombo() {
    let that = this;

    this.combo2Service.agentCombo().then((res: any) => {
      that.agentList = res.data;
      // setTimeout(function () {
      //     that.displayAgent('Agent', that.user.params.agent_id);
      // }, 200);
    });
  }
  bsModalRef: BsModalRef;
  addEditBrandStock(mode: string, row: any): void {
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.getOrderList();
    });
    row.tabevent = listUpdateEvent;
    let tabObj = {};
    if (mode == "Add") {
      tabObj = {
        action: "NewTab",
        params: {
          //  tabParent: 'Transaction',
          tabName: "ADD BRAND STOCK INWARD",
          title: "ADD BRAND STOCK INWARD",
          tabParent: "SALES_PLAN",
          mode: mode,
          data: row,
          name: "ADD BRAND STOCK",
        },
      };
    } else {
      tabObj = {
        action: "NewTab",
        params: {
          //   tabParent: 'Transaction',
          tabName: "VIEW BRAND STOCK",
          title: "VIEW BRAND STOCK",
          tabParent: "SALES_PLAN",
          mode: mode,
          data: row,
          name: "VIEW BRAND STOCK",
        },
      };
    }

    this.tabUpdateEvent.emit(tabObj);
  }
  getPartyList() {
    let params = {
      page: 1,
      start: 0,
      limit: 100,
    };
    this.comboservice.getSalesParty(params).then((res: any) => {
      this.partyList = res;
    });
  }
  onSelectParty(party) {
    this.partyList.forEach((element) => {
      if (party == element.name) {
        this.filter.party_id = element.genLedid;
      }
    });
  }
  onSelectAgent(event) {
    this.filter.agent_id = event.agent_id;
  }
  getOrderList(): void {
    if (this.filter.order_from_date) {
      this.filter.order_from_date = this.datePipe.transform(
        this.filter.order_from_date,
        "yyyy-MM-dd"
      );
    }
    if (this.filter.order_to_date) {
      this.filter.order_to_date = this.datePipe.transform(
        this.filter.order_to_date,
        "yyyy-MM-dd"
      );
    }
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      wo_type: "Sales",
      order_from_date: this.filter.order_from_date,
      order_to_date: this.filter.order_to_date,
      party_id: this.filter.party_id,
      agent_id: this.filter.agent_id,
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.salesservice
      .getBrandStockInwardList(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.total;
        that.orderList = res.data;
        for (let i = 0; i < res.data.length; i++) {
          that.orderList[i].so_dateformatted = that.datePipe.transform(
            res.data[i].so_date,
            "dd-MM-yyyy"
          );
        }
      });
  }

  deleteOrder(row: any): void {
    let that = this;
    row.tabevent = undefined;
    let params = {
      so_id: row.so_id,
    };
    swal({
      title: "Are you sure to delete this Order Details?",
      text:
        "You will not be able to recover this Order" + " " + row["so_no"] + "",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then(
      function () {
        that.isLoadMask = that.salesservice
          .delsalesOrder(params)
          .then(function (res: any) {
            that.loadingIndicator = false;
            that.getOrderList();
            let errtype = "success",
              errmsg = res.message;
            if (!res.success) {
              errtype = "error";
            }

            that.toasterService.pop({
              bodyOutputType: 1,
              type: errtype,
              title: errtype.toUpperCase(),
              body: errmsg,
            });
          });
      },
      function (dismiss) {}
    );
  }

  boxprintModal(row) {
    this.brand = row.brand;
    let params = {
      br_id: row.so_id,
    };
    this.salesservice.boxprintModal(params).then((res: any) => {
      this.printPreview = res.data;
    });
  }

  printer() {
    this.noofpcs = 1;
    if ($("#box").is(":checked")) {
      this.box = true;
    } else {
      this.box = false;
    }
    if ($("#shirt").is(":checked")) {
      this.shirt = true;
    } else {
      this.shirt = false;
    }
    if (this.box == false && this.shirt == false) {
      swal("PLEASE SELECT ATLEAST ONE");
    } else {
      $("#box").prop("checked", false);
      $("#shirt").prop("checked", false);
    }
    let params = {
      noofpcs: this.noofpcs,
      box: this.box,
      shirt: this.shirt,
      brand: this.brand,
      designdet: JSON.stringify(this.printPreview),
    };
    this.stockService.print(params).then((res: any) => {});
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Sales/brandStockInward/brandStock.ts